import { isBandScale } from './isBandScale';
import { ScaleWithValueType } from './SupportedScale';

/**
 * Determine the scaled value corresponding to a given unscaled value, given a scale and unscaled
 * value.
 *
 * For band scales, returns a value in the middle of the corresponding band, or `undefined` if the
 * given value is not in the scale's domain.
 *
 * For numeric scales, returns the scaled numeric value according to the scale's configuration.
 *
 * @param scale The scale to use on the given value.
 * @param value The unscaled value.
 */
export const getScaledValue = <TValueType>(
  scale: ScaleWithValueType<TValueType>,
  value: TValueType,
): ReturnType<ScaleWithValueType<TValueType>> => {
  const scaledValue = scale(value) as ReturnType<ScaleWithValueType<TValueType>>;
  if (typeof scaledValue === 'number' && isBandScale(scale)) {
    const bandwidth = scale.bandwidth();
    if (bandwidth > 0) {
      return (scaledValue + bandwidth / 2) as ReturnType<ScaleWithValueType<TValueType>>;
    }
  }

  return scaledValue;
};
